import {BASIC_PACKAGE_DATA} from 'constants/packages';
import {USAGES_WITH_5_PACKAGES, WIZARD_ID_WITH_5_PACKAGES} from 'constants/product';
import {QuoteItemV2OptionType} from 'desktop/pages/cart/types/quoteItem';
import {CheckoutItemOptionType} from 'desktop/types/checkoutItemsType';

/**
 * Detect flag for 5 packages
 */
const isPdp5Pack = ({
    activeUsageSku,
    isWizard = true,
    wizardId,
}: {
    wizardId?: string | undefined;
    activeUsageSku: string;
    isWizard?: boolean;
}) => {
    const isWizardIdWith5Packages = Boolean(
        !isWizard || (wizardId && WIZARD_ID_WITH_5_PACKAGES.includes(wizardId)),
    );

    return isWizardIdWith5Packages && USAGES_WITH_5_PACKAGES.includes(activeUsageSku);
};

/**
 * Get Package Basic data (title and description)
 */
export const getPackageBasicData = ({
    description,
    isEyeglasses,
    options,
    title,
}: {
    title: string;
    description: string;
    isEyeglasses: boolean;
    options: {[key: string]: QuoteItemV2OptionType} | {[p: string]: CheckoutItemOptionType};
}) => {
    const usageOption = Object.values(options).find(({option}) => option.alias === 'usage');

    const hasFivePacks = isPdp5Pack({
        activeUsageSku: usageOption ? usageOption.sku : '',
        isWizard: false,
    });

    if (isEyeglasses && hasFivePacks && (title === 'Value' || title === 'Silver')) {
        return BASIC_PACKAGE_DATA;
    }

    return {description, title};
};
